<template>
  <div>
    <b-tabs :multiline="true" :animated="false">
      <b-tab-item>
        <template #header>
          <b-tooltip
            :label="$t('compCarbonDocsHelpCalculatingMethods.title-1')"
            type="is-black"
          >
            <b-icon icon="info" />
          </b-tooltip>
        </template>
        <b-notification :closable="false">
          {{ $t('compCarbonDocsHelpCalculatingMethods.generic-1') }}<br />
          {{ $t('compCarbonDocsHelpCalculatingMethods.generic-2') }}CO<sub
            >2</sub
          >{{ $t('compCarbonDocsHelpCalculatingMethods.generic-2b') }} ({{
            $t('kg.co2e')
          }})<br /><br />
          {{ $t('compCarbonDocsHelpCalculatingMethods.generic-3') }}
          {{ $t('kg.co2e') }}
          {{ $t('compCarbonDocsHelpCalculatingMethods.generic-4') }}
          {{ $t('kg.co2e') }}
          {{ $t('compCarbonDocsHelpCalculatingMethods.generic-5') }}<br /><br />
          {{ $t('compCarbonDocsHelpCalculatingMethods.generic-6') }}<br />
          {{ $t('compCarbonDocsHelpCalculatingMethods.generic-7')
          }}<span class="icon is-small"><i class="fa fa-cloud"></i></span
          >{{ $t('compCarbonDocsHelpCalculatingMethods.generic-8')
          }}<em>Ekocentral</em
          >{{ $t('compCarbonDocsHelpCalculatingMethods.generic-9') }}
        </b-notification>

        <b-notification :closable="false">
          <b>{{ $t('compCarbonDocsHelpCalculatingMethods.subtit-comb') }}</b
          ><br />
          {{ $t('compCarbonDocsHelpCalculatingMethods.comb-1') }}<br />
          {{ $t('compCarbonDocsHelpCalculatingMethods.comb-2') }}
        </b-notification>
      </b-tab-item>
      <b-tab-item
        v-for="(module, index) in modules"
        :key="index"
        :icon="getIcon(module)"
      >
        <template #header>
          <b-tooltip :label="$t(module)" type="is-black">
            <b-icon :icon="getIcon(module)" />
          </b-tooltip>
        </template>
        <component :is="importName(module)" />
      </b-tab-item>
      <b-tab-item>
        <template #header>
          <b-tooltip
            :label="$t('compCarbonDocsHelpCalculatingMethods.title-2')"
            type="is-black"
          >
            <b-icon icon="check" />
          </b-tooltip>
        </template>
        <b-notification :closable="false">
          <b>{{
            $t('compCarbonDocsHelpCalculatingMethods.subtit-uncertainty-1')
          }}</b
          ><br />
          <span
            v-html="$t('compCarbonDocsHelpCalculatingMethods.uncertainty-1')"
          />
        </b-notification>
        <b-notification :closable="false">
          <b>{{
            $t('compCarbonDocsHelpCalculatingMethods.subtit-uncertainty-2')
          }}</b
          ><br />
          <span
            v-html="$t('compCarbonDocsHelpCalculatingMethods.uncertainty-2')"
          />
        </b-notification>
        <b-notification :closable="false">
          <b>{{
            $t('compCarbonDocsHelpCalculatingMethods.subtit-uncertainty-3')
          }}</b
          ><br />
          <span
            v-html="$t('compCarbonDocsHelpCalculatingMethods.uncertainty-3')"
          />
        </b-notification>
        <b-notification :closable="false">
          <b
            v-html="
              $t('compCarbonDocsHelpCalculatingMethods.subtit-uncertainty-4')
            "
          /><br />
          <span
            v-html="$t('compCarbonDocsHelpCalculatingMethods.uncertainty-4')"
          />
        </b-notification>
        <b-notification :closable="false">
          <object
            data="/static/carbon/uncertaintyAbstract.pdf"
            type="application/pdf"
            style="
              min-height: 180px;
              width: 100%;
              border: 1px solid lightgray;
              border-radius: 10px;
            "
          >
            <p>
              It appears you don't have a PDF plugin for this browser... <br />
              You can
              <a class="link" href="/static/carbon/uncertaintyAbstract.pdf"
                >click here to download the PDF file.</a
              >
            </p>
          </object>
          <span
            v-html="$t('compCarbonDocsHelpCalculatingMethods.uncertainty-5')"
          />
        </b-notification>
        <b-notification :closable="false">
          <object
            data="/static/carbon/uncertaintyFull.pdf"
            type="application/pdf"
            style="
              min-height: 760px;
              width: 100%;
              border: 1px solid lightgray;
              border-radius: 10px;
            "
          >
            <p>
              It appears you don't have a PDF plugin for this browser... <br />
              You can
              <a class="link" href="/static/carbon/uncertaintyFull.pdf"
                >click here to download the PDF file.</a
              >
            </p>
          </object>
          <span
            v-html="$t('compCarbonDocsHelpCalculatingMethods.uncertainty-6')"
          />
        </b-notification>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import Modules from '@/models/Modules.js'
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'HelpCalculatingMethods',
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    modules: function () {
      // we only want the top level module types of active modules
      return this.coreStore.activeModules(false)
    }
  },
  methods: {
    getIcon: function (module) {
      return Modules.getIcon(module)
    },
    importName: function (module) {
      return module + 'HelpCalc'
    }
  },
  beforeMount () {
    for (let module of this.modules) {
      Vue.component(
        this.importName(module),
        // A dynamic import returns a Promise.
        () =>
          import(
            '@/components/carbon/forms/' + module + '/HelpCalculatingMethod.vue'
          )
      )
    }
  }
}
</script>
